import {atom} from "recoil";

/**
 * 참조함 문서 상태
 * @type {RecoilState<number>}
 */
export const docReferenceState = atom({
    key: "docReferenceState"
    , default: {
        nowPage: 1,
        docsNum: 10,
        ascending: 'DESC',
        searchEndStart: '',
        searchEndEnd: '',
        searchStartStart: '',
        searchStartEnd: '',
        searchName: '',
        searchTeam: '',
        searchCategory: '',
    }
})